import React from 'react';

import {ProteinAnnotationsPanelState} from 'FileStates';
import Protein from 'molbio/proteins/Protein';
import ProteinAnnotationsPanel from 'toolbar/protein/ProteinAnnotationsPanel';
import ReactPanelBaseView, {getTabAndPanelIds, Subpanel} from 'toolbar/ReactPanelBaseView';

class ProteinAnnotationsPanelView extends ReactPanelBaseView<ProteinAnnotationsPanelState, Protein> {
  _jumpToSelection = (start: number, end: number): void => {
    this.model.selection().triggerJump(start, end);
  };

  getSubpanels(): Array<Subpanel> {
    return [
      {
        ...getTabAndPanelIds('proteinAnnotations'),
        title: 'Annotations',
        component: (
          <ProteinAnnotationsPanel proteinId={this.model.id} jumpToSelection={this._jumpToSelection} />
        ),
      },
    ];
  }
}

export default ProteinAnnotationsPanelView;
